<template>
  <va-modal
    size="large"
    id="lead-entity-update-modal"
    ref="leadEntityUpdateModal"
    class="leadEntityUpdateModal"
    v-model="showLeadEntityUpdateModal"
    :okToClose="canClose"
    :okText="$t('users.save')"
    :okDisabled="isSubmitting || !canSubmit"
    @ok="updateLeadEntity"
    @cancel="closeLeadEntityUpdateModal"
    :cancelText="$t('users.cancel')"
    :noOutsideDismiss="true"

  >

    <div slot="header" class="modal-title">
      {{ getTitleHeader }}
    </div>

    <div>
      <p>{{ $t('leads.details.currentEntity') }}:
        <span class="is-bold">{{
            selectedLead.entity
          }}</span>
      </p>
      <p>{{ $t('leads.details.currentFacility') }}:
        <span class="is-bold">{{
            selectedLead.facility
          }}</span>
      </p>
    </div>

    <div :class="[isDropdownOpened ? 'dropdownExpanded' : 'dropdownClosed','row']">
      <h4 class="mt-3"> Nova entidade </h4>

      <div class="row col-12">
        <div class="col-12 col-md-6">
          <label class="form-label">
            {{ $t('users.inputs.entity') }}
          </label>
          <multiselect
            id="entity-selection"
            v-model="selectedEntity"
            :options="entitiesWrite"
            track-by="id"
            :customLabel="formatedEntityLabel"
            placeholder="---"
            :allow-empty="true"
            :multiple="false"
            :internal-search="true"
            :disabled="!entitiesWrite.length || isLoading"
            @open="isDropdownOpened = true"
            @close="isDropdownOpened = false"
          >

            <template slot="clear">
            <span class="multiselect__clear" v-if="selectedEntity !== null"
                  @mousedown.prevent.stop="selectedEntity = null"></span>
            </template>
          </multiselect>
        </div>
        <div class="col-12 col-md-6">
          <label class="form-label">
            {{ $t('kiosks.facility') }}
          </label>
          <multiselect
            id="facility-selection"
            v-model="selectedFacility"
            :options="facilitiesOptions"
            track-by="id"
            :customLabel="formatedEntityLabel"
            placeholder="---"
            :allow-empty="true"
            :multiple="false"
            :internal-search="true"
            :disabled="!facilitiesOptions.length || isLoading"
            @open="isDropdownOpened = true"
            @close="isDropdownOpened = false"
          >

            <template slot="clear">
            <span class="multiselect__clear" v-if="selectedFacility !== null"
                  @mousedown.prevent.stop="selectedFacility = null"></span>
            </template>
          </multiselect>
        </div>
      </div>

    </div>

    <span class="small text-danger ml-3" v-show="selectedEntity !== null && selectedEntity.facilities.length === 0">
                {{ $t('leads.errors.updateLeadsNoFacilities') }}
    </span>


  </va-modal>
</template>


<script>
import MultiselectLabelFormatter from "@/mixins/MultiselectLabelFormatter";
import Multiselect from 'vue-multiselect'
import {LeadsService} from "@/api/LeadsService";

export default {
  components: {
    Multiselect
  },
  mixins: [MultiselectLabelFormatter],
  props: {
    selectedLead: {
      type: Object,
      required: true
    },
    entitiesWrite: {
      type: Array,
      required: true
    },
  },
  mounted() {
    this.showLeadEntityUpdateModal = true
  },
  data() {
    return {
      showLeadEntityUpdateModal: false,
      isLoading: false,
      canClose: true,
      isSubmitting: false,
      selectedEntity: null,
      selectedFacility: null,
      isDropdownOpened: false,
      facilitiesOptions: []
    }
  },
  methods: {
    closeLeadEntityUpdateModal: function () {
      this.$emit('closeUpdateEntityModal')
    },
    updateLeadEntity: async function () {
      const params = {
        "entity_id": this.selectedEntity.id,
        "facility_id": this.selectedFacility.id
      }

      try {
        const response = await LeadsService.updateLeadEntity(this.selectedLead.id, params)
        const lead = response.data.data
        this.$emit('updatedLeadEntity', lead )
        this.showToast(this.$t('leads.update_entity.success'), this.$store.state.successToastOptions)
      } catch (error) {
        console.log(error)
      }

    }
  },
  computed: {
    canSubmit: function () {
      return this.selectedEntity !== null && this.selectedEntity.facilities.length > 0 && this.selectedFacility !== null
    },
    getTitleHeader: function () {
      return this.$t('leads.updateEntity') + ' - ' + ` ${this.selectedLead.name}` + (this.selectedLead.surname ? ` ${this.selectedLead.surname}` : '')
    }
  },
  watch: {
    selectedEntity: function (value) {
      if (value && value.facilities && value.facilities.length > 0) {
        this.facilitiesOptions = value.facilities
        if(this.facilitiesOptions.length === 1) {
          this.selectedFacility = this.facilitiesOptions[0]
        }
      } else {
        this.facilitiesOptions = []
        this.selectedFacility = null
      }
    }
  }
}
</script>

<style lang="scss">

.dropdownExpanded {
  margin-bottom: 180px;
}

.dropdownClosed {
  margin-bottom: unset;
}
</style>
